<div class="genie-page">
  <!-- Page Header Section -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <div class="header-title-group">
        <p class="genie-page-title">{{ 'Users' | translate }}</p>
        <p class="genie-page-subtitle">{{ 'Manage your app users and their accounts' | translate }}</p>
      </div>
    </div>
    <div class="header-right">
      <button class="genie-btn primary" [routerLink]="['/create-user']">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        {{ 'Add New User' | translate }}
      </button>
    </div>
  </div>
  <!-- Statistics Overview -->
  <div class="statistics-section">
    <div class="statistics-grid">
      <div class="statistic-card" *ngFor="let item of statisticsData">
        <span class="stat-label">{{ item.name | translate }}</span>
        <span class="stat-value">{{ item.value | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Main Content Card -->
  <div class="genie-content-card">
    <!-- Empty State -->
    <div class="genie-empty-state" *ngIf="AppUsersService.users?.length === 0">
      <p class="no-users">{{ 'No Users Yet' | translate }}</p>
    </div>

    <!-- Users Table Section -->
    <ng-container *ngIf="AppUsersService.users?.length !== 0">
      <!-- Toolbar -->
      <div class="genie-toolbar">
        <div class="toolbar-left">
          <!-- Search Input -->
          <div class="search-input-wrapper">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="currentColor" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11 11L10 10" stroke="currentColor" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <input type="text" (input)="applyFilter()" [(ngModel)]="searchText" placeholder="{{ 'Search' | translate }}..." />
          </div>
        </div>

        <div class="toolbar-right">
          <app-backup *ngIf="this.loginService.getCurrentUser().admin" backupNode="users"></app-backup>
        </div>
      </div>

      <!-- Data Table -->
      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th class="col-name">{{ 'User Name' | translate }}</th>
              <th class="col-email">{{ 'Email' | translate }}</th>
              <th class="col-date">{{ 'Registration Date' | translate }}</th>
              <th class="col-verified col-center">{{ 'Email Verified' | translate }}</th>
              <th class="col-role">{{ 'User Role' | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of displayedUsers">
              <td class="col-name">{{ user.nickname }}</td>
              <td class="col-email">{{ user.email }}</td>
              <td class="col-date">{{ user.date }}</td>
              <td class="col-verified col-center">
                <span class="genie-badge" [ngClass]="user.email_verified ? 'success' : 'danger'">
                  {{ (user.email_verified ? 'Yes' : 'No') | translate }}
                </span>
              </td>
              <td class="col-role">{{ getRoleLabel(user.role) | translate }}</td>
              <td class="col-actions">
                <div class="genie-action-buttons">
                  <button class="genie-icon-btn view" (click)="editUser(user.user_id)" matTooltip="{{ 'View User' | translate }}">
                    <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 2.8125C4.375 2.8125 1.75625 4.80625 0.625 7.5C1.75625 10.1937 4.375 12.1875 7.5 12.1875C10.625 12.1875 13.2437 10.1937 14.375 7.5C13.2437 4.80625 10.625 2.8125 7.5 2.8125Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7.5 9.6875C8.70812 9.6875 9.6875 8.70812 9.6875 7.5C9.6875 6.29188 8.70812 5.3125 7.5 5.3125C6.29188 5.3125 5.3125 6.29188 5.3125 7.5C5.3125 8.70812 6.29188 9.6875 7.5 9.6875Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <button class="genie-icon-btn delete" (click)="deleteUser(user.user_id, user.nickname)" matTooltip="{{ 'Delete User' | translate }}">
                    <svg width="18" height="18" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438"
                        stroke="currentColor"
                        stroke-width="1.467"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Custom Pagination -->
      <div class="genie-pagination">
        <div class="pagination-pageSize">
          <span class="pageSize-label">{{ 'Items per page' | translate }}:</span>
          <select class="pageSize-select" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
        </div>
        <div class="pagination-info">
          <span class="current-page">{{ pageIndex + 1 }}</span>
          <span class="page-separator">{{ 'of' | translate }}</span>
          <span class="total-pages">{{ getTotalPages() }}</span>
        </div>
        <div class="pagination-controls">
          <button class="page-btn prev" [disabled]="pageIndex === 0" (click)="previousPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button class="page-btn next" [disabled]="pageIndex >= getTotalPages() - 1" (click)="nextPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
